var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BBadge',{class:`bg-white border my-auto mr-2 ${_vm.tierColor}-tenant tenant-badge`,attrs:{"data-testid":"tenant-tier-badge"}},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }